import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import CustomerData from './CustomerData';

const Countries = gql`
  query {
    countries {
      id
      parentCountryId
      name
      title
      details
      slug
      VATrate
      currency
      language
      code
      flag
      weightUnit
      business {
        id
      }
      states {
        id
        name
        title
        vatRate
      }
    }
  }
`;

const RequestCompanyChangeMutation = gql`
  mutation requestCompanyChange($user: IUserInput!) {
    requestCompanyChange(userData: $user)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(Countries, {
    name: 'countries'
  }),
  graphql<IInputProps, IResponse>(RequestCompanyChangeMutation, {
    name: 'requestCompanyChange'
  })
)(CustomerData);



// WEBPACK FOOTER //
// ./src/components/CustomerData/index.tsx